import { render, staticRenderFns } from "./webgis.vue?vue&type=template&id=2fa06bf4"
import script from "./webgis.ts?vue&type=script&lang=js&external"
export * from "./webgis.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports